// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: '',
  fileUploadURL: '',
  currencyFormat: 'en-US',
  commonPublisher: '',
  accountsPublisher:'',
  customersPublisher: '',
  depositsPublisher:'',
  cardsPublisher: '',
  loansPublisher:'',
  billpaymentsPublisher:'',
  transfersPublisher:'',
  defaultPublisher: '',
  languageId: '',
  googleMapVariable: 'QUl6YVN5Q05zaV9Iem9IS0xmcmNyMmFwUElueFlsbFREaGphSEVr',
  googleMapApiURL:'https://maps.googleapis.com/maps/api/distancematrix/json?',
  branchLocatorRadius:25,
  atmLocatorRadius:25,
  enablePushNotification: false,
  playstoreURL: "https://play.google.com/store/apps/",
  appstoreURL: "https://apps.apple.com/",
  msmntd:''
};

